//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Navigation",

  props: {
    types: {
      type: Array,
      default: () => {
        return []
      }
    },
    stages: {
      type: Array,
      default: () => {
        return []
      }
    },
    form: {
      type: Object,
      default: () => {
        return {}
      }
    },
    stage: {
      type: Number,
      default: 1
    },
    maxStage: {
      type: Number,
      default: 1
    },
  },

  watch: {
    stage: function () {
      this.scrollToStage();
    },
  },

  computed: {
    selectedType: function () {
      return (this.types || []).find((t) => t.value === this.form.type)?.label
    }
  },

  methods: {
    changeStage: function (stage) {
      if (this.maxStage < stage) {
        return
      }
      this.$emit('change', stage)
    },
    scrollToStage: function () {
      if (window.innerWidth >= 860) {
        return
      }

      const element = document.querySelector(`[data-sertifikaty-navigation-stage="${ this.stage }"]`);
      if (!element) {
        return;
      }

      const rootLeft = this.$refs.refNavigation.getBoundingClientRect().x;
      const leftPosition = element.getBoundingClientRect().x;

      this.$refs.refNavigation.scrollBy({
        left: leftPosition - rootLeft - 10
      });
    },
  }
}
